if (!customElements.get('atelier-weezevent')) {
  customElements.define(
    'atelier-weezevent',
    class AtelierWeezevent extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      }

      connectedCallback() {
        this.overlay = this.querySelector('[data-atelier-overlay]');
        this.toast = this.querySelector('[data-atelier-toast]');
        this.addEventListener('click', this.handleClick);
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
        clearTimeout(this.toastTimer);
        this.closeModal();
      }

      handleClick(event) {
        const opener = event.target.closest('[data-atelier-open]');
        if (opener) {
          this.openModal(opener);
          return;
        }

        if (event.target.closest('[data-atelier-booking]')) this.showToast();
        if (event.target.closest('[data-atelier-close]') || event.target === this.overlay) this.closeModal();
      }

      handleKeydown(event) {
        if (!this.isOpen()) return;

        if (event.key === 'Escape') {
          this.closeModal();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = this.overlay.querySelectorAll('a[href], button');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (!this.overlay.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleBlockSelect(event) {
        if (this.overlay && this.overlay.contains(event.target)) this.openModal(null, false);
      }

      handleBlockDeselect(event) {
        if (this.overlay && this.overlay.contains(event.target)) this.closeModal();
      }

      isOpen() {
        return Boolean(this.overlay && this.overlay.classList.contains('is-active'));
      }

      openModal(opener, moveFocus = true) {
        if (!this.overlay || this.isOpen()) return;

        this.opener = opener;
        this.previousOverflow = document.body.style.overflow;
        this.overlay.classList.add('is-active');
        document.body.style.overflow = 'hidden';

        if (moveFocus) this.overlay.querySelector('[data-atelier-close]').focus({ preventScroll: true });
      }

      closeModal() {
        if (!this.isOpen()) return;

        this.overlay.classList.remove('is-active');
        document.body.style.overflow = this.previousOverflow || '';

        if (this.opener) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }

      showToast() {
        if (!this.toast) return;

        clearTimeout(this.toastTimer);
        this.toast.classList.add('is-visible');
        this.toastTimer = setTimeout(() => this.toast.classList.remove('is-visible'), 3500);
      }
    }
  );
}
